import RouteSearchHook from './RouteSearchHook';

export default RouteSearchHook;
